/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const WEIGHBRIDGE_PURCHASE_COLUMNS = [
  { id: "created_at", label: "Date", accessorKey: "created_at", filterType: "date", sortable: true },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "code", label: "Purchase", accessorKey: "code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  {
    id: "state",
    label: "State",
    accessorKey: "state",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "GATE_IN", label: "Gate in" },
      { value: "WEIGH_GROSS", label: "Weigh gross" },
      { value: "WEIGH_MID", label: "Weigh mid" },
      { value: "UNLOADING", label: "Unloading" },
      { value: "WEIGH_TARE", label: "Weigh tare" },
      { value: "APPROVED", label: "Approved" },
      { value: "ACCOUNTS_PENDING", label: "Accounts" },
      { value: "COMPLETED", label: "Completed" },
    ],
    matchFilter: (row, value) => !value || row.state === value,
  },
  { id: "gross_weight_qtl", label: "Gross qtl", accessorKey: "gross_weight_qtl", filterType: "text" },
  { id: "tare_weight_qtl", label: "Tare qtl", accessorKey: "tare_weight_qtl", filterType: "text" },
  { id: "net_weight_qtl", label: "Net qtl", accessorKey: "net_weight_qtl", filterType: "text" },
  { id: "party_net_weight_qtl", label: "Party net", accessorKey: "party_net_weight_qtl", filterType: "text" },
];

/** Weighment register tab — purchases with at least one weight recorded. */
export const WEIGHMENT_REGISTER_COLUMNS = [
  { id: "created_at", label: "Date", accessorKey: "created_at", filterType: "date", sortable: true },
  { id: "vehicle_number", label: "Vehicle", accessorKey: "vehicle_number", filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  { id: "variety", label: "Variety", accessorKey: "variety", filterType: "text" },
  { id: "gross_weight_qtl", label: "Gross qtl", accessorKey: "gross_weight_qtl", filterType: "text" },
  { id: "tare_weight_qtl", label: "Tare qtl", accessorKey: "tare_weight_qtl", filterType: "text" },
  { id: "net_weight_qtl", label: "Net qtl", accessorKey: "net_weight_qtl", filterType: "text" },
  { id: "party_net_weight_qtl", label: "Party net", accessorKey: "party_net_weight_qtl", filterType: "text" },
  // Filter-only (not shown in register table)
  { id: "code", label: "Purchase", accessorKey: "code", filterType: "text", hideInTable: true },
  {
    id: "state",
    label: "State",
    accessorKey: "state",
    filterType: "select",
    hideInTable: true,
    filterOptions: [
      { value: "", label: "All" },
      { value: "GATE_IN", label: "Gate in" },
      { value: "WEIGH_GROSS", label: "Weigh gross" },
      { value: "WEIGH_MID", label: "Weigh mid" },
      { value: "UNLOADING", label: "Unloading" },
      { value: "WEIGH_TARE", label: "Weigh tare" },
      { value: "APPROVED", label: "Approved" },
      { value: "ACCOUNTS_PENDING", label: "Accounts" },
      { value: "COMPLETED", label: "Completed" },
    ],
    matchFilter: (row, value) => !value || row.state === value,
  },
];
